import React from "react";

function Title({ text }) {
  return (
    <h1 className="font-medium text-3xl p-4 border-b text-black border-black/40">
      {text}
    </h1>
  );
}

export default Title;
